// extracted by mini-css-extract-plugin
export var button = "CookieRequest-module--button--JJPW8";
export var container = "CookieRequest-module--container--ZRGS2";
export var foregroundContainer = "CookieRequest-module--foreground-container--bNL7G";
export var image = "CookieRequest-module--image--fUL7q";
export var paragraph = "CookieRequest-module--paragraph--RgeT+";
export var title = "CookieRequest-module--title--fqAYo";